import {
  GetTranslations,
  getTranslations,
} from "@timeedit/registration-shared";
import { useParams } from "react-router-dom";

export function useLanguage(): GetTranslations {
  const { lang } = useParams();

  return getTranslations(lang);
}
